<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <navbar />
  <div class="login-container auth-container">
    <el-card class="login-card auth-card" shadow="always">
      <template #header>
        <div class="card-header auth-header">
          <img src="../assets/logo2.jpeg" alt="Wedoomotion" class="auth-logo" />
          <h2>Se connecter sur Wedoomotion</h2>
          <p class="auth-subtitle">Retrouvez la communauté Wedoomotion</p>
        </div>
      </template>

      <el-form label-position="top" @submit.prevent>
        <el-form-item label="E-mail">
          <el-input
            v-model="email"
            type="email"
            placeholder="Votre adresse e-mail"
            :prefix-icon="Message"
          />
        </el-form-item>

        <el-form-item label="Mot de passe">
          <el-input
            v-model="password"
            type="password"
            placeholder="Votre mot de passe"
            :prefix-icon="Lock"
            show-password
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" class="full-width" @click="login">
            Se connecter
          </el-button>
        </el-form-item>
      </el-form>

      <el-alert
        v-if="error"
        :title="error"
        type="error"
        show-icon
        :closable="false"
        class="login-alert"
      />

      <div class="register-link">
        <span>Pas encore de compte ?</span>
        <router-link to="/register">
          <el-button link type="primary">S'inscrire</el-button>
        </router-link>
      </div>
    </el-card>
  </div>
</template>

<script>
import '@/styles/auth.css'
import api from '@/api';
import Navbar from '@/components/Navbar.vue'
import { Message, Lock } from '@element-plus/icons-vue'

export default {
  components: {
    Navbar,
  },

  data() {
    return {
      email: '',
      password: '',
      error: null,
    }
  },

  computed: {
    Message() {
      return Message
    },
    Lock() {
      return Lock
    },
  },

  mounted() {
    document.body.style.backgroundColor = 'rgba(21, 109, 123)'
  },

  methods: {
    login() {
      api
        .post(
          '/session/login',
          {
            email: this.email,
            password: this.password,
          },
          {
            withCredentials: true,
          }
        )
        .then(() => {
          sessionStorage.setItem('userEmail', this.email)
          this.$router.push('/Rubriques')
        })
        .catch((error) => {
          if (error.response?.data?.message) {
            this.error = error.response.data.message
          } else {
            this.error = 'E-mail ou mot de passe incorrect. Veuillez réessayer.'
          }
        })
    },
  },
}
</script>

<style scoped>
.full-width {
  width: 100%;
}

.login-alert {
  margin-bottom: 16px;
}

.register-link {
  text-align: center;
  margin-top: 8px;
  color: #606266;
}

.register-link span {
  margin-right: 4px;
}
</style>
